import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { McpSettingDto } from '@/Domain/api/Action/dto/McpSetting.dto';
import { McpSettingForm } from '@/Domain/hooks/Action/useMcpForm/useMcpForm';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class McpApi {
  static get = (): Promise<McpSettingDto> =>
    httpClient.get(Endpoint.mcp.get).then(ApiMapper.toResponseData);

  static patch = (data: Partial<McpSettingForm>): Promise<McpSettingDto> =>
    httpClient.patch(Endpoint.mcp.patch, data).then(ApiMapper.toResponseData);
}
